import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, tokens, shorthands, mergeClasses } from '@fluentui/react-components';
import classNames from 'classnames';
import { CheckmarkCircleFilled } from '@fluentui/react-icons';
import {
  TilesGridCellImage as CellImage,
} from '../../ads-studio-tile-grid';

export const useStyles = makeStyles({
  imageWrapper: {
    position: 'relative',
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    ...shorthands.outline('2px', 'solid', '#0078d4'),
  },
  containerClass: {
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.14)',
  },
  imageClass: {
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
  },
  iconChecked: {
    top: '9px',
    right: '10px',
    position: 'absolute',
    color: '#0078d4',
    fontSize: '20px',
    backgroundColor: '#ffffff',
    ...shorthands.borderRadius(tokens.borderRadiusCircular),
  },
});

export const ImagePanelGridCell = (props) => {
  const {
    item, i18n, onSelectImage, isSelected, isMultiple,
  } = props;
  const { url, id } = item || {};
  const classes = useStyles();

  const onClickCell = useCallback(() => {
    onSelectImage(id);
  }, [id, onSelectImage]);

  return (
    <div className={isSelected ? mergeClasses('selected-image-wrapper', classes.imageWrapper) : ''}>
      <CellImage
        src={url}
        alt={id || ''}
        showSpinner={false}
        i18n={i18n}
        onClick={onClickCell}
        customClasses={{ containerClass: classNames('panel-image-cell', classes.containerClass), imageClass: mergeClasses('cell-image', classes.imageClass) }}
      />
      {isSelected && isMultiple && <CheckmarkCircleFilled className={classNames('checked-icon', classes.iconChecked)} />}
    </div>
  );
};

ImagePanelGridCell.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  item: PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  onSelectImage: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isMultiple: PropTypes.bool,
};

ImagePanelGridCell.defaultProps = {
  isMultiple: true,
};

